import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-qa": "guest-section-form" }
const _hoisted_2 = { class: "gfu-1of1 gfu-1of2--m _flexcol _gap-3" }
const _hoisted_3 = { "format-key": "0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_text_field = _resolveComponent("text-field")
  const _component_localize = _resolveComponent("localize")
  const _component_checkbox_field = _resolveComponent("checkbox-field")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_text_field, {
        modelValue: $options.model.email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.model.email) = $event)),
        "display-name": _ctx.Resources.Checkout.EmailFieldLabel,
        name: "guestCheckout.model.email",
        class: "_mt-0",
        "read-only": $props.readOnly,
        description: _ctx.Resources.Checkout.EmailFieldDescription,
        "data-qa": "guest-checkout:Email"
      }, null, 8 /* PROPS */, ["modelValue", "display-name", "read-only", "description"]),
      _createVNode(_component_text_field, {
        modelValue: $options.model.confirmationEmail,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($options.model.confirmationEmail) = $event)),
        "display-name": _ctx.Resources.Checkout.EmailConfirmationFieldLabel,
        name: "guestCheckout.model.confirmationEmail",
        class: "_mt-0",
        "read-only": $props.readOnly,
        description: _ctx.Resources.Checkout.EmailConfirmationFieldDescription,
        "data-qa": "guest-checkout:ConfirmationEmail"
      }, null, 8 /* PROPS */, ["modelValue", "display-name", "read-only", "description"])
    ]),
    _createVNode(_component_checkbox_field, {
      modelValue: $options.model.createAccount,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($options.model.createAccount) = $event)),
      inline: true,
      condensed: true,
      class: "_mb-0 _mt-3",
      "read-only": $props.readOnly,
      type: "checkbox",
      "data-qa": "guest-checkout:CreateAccountCheckbox"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_localize, {
          resource: _ctx.Resources.Checkout.CreateAccountCheckboxLabel
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, _toDisplayString($options.platformName), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["resource"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "read-only"])
  ]))
}